import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PaymentRoutingModule } from './payment-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, PaymentRoutingModule]
})
export class PaymentModule {}
